/* globals document */

/**
 * Add an external script to the page. Returns a promise
 * that's resolved on script 'load', and rejected on any error.
 * @param  {String} url - location of the script
 * @return {Promise}
 */
export function loadScript (url) {
  return new Promise((resolve, reject) => {
    const body = document.querySelector('body')
    const script = document.createElement('script')

    script.addEventListener('load', resolve)
    script.addEventListener('error', reject)

    script.src = url
    body.appendChild(script)
  })
}
